import React, { useState, useEffect } from 'react';
import './BauhausPattern.css';

const BauhausPattern = () => {
    const [pos, setPos] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Control + Arrow Keys to move the background
            if (e.ctrlKey) {
                const step = 10; // Pixels to move per press
                switch (e.key) {
                    case 'ArrowUp':
                        setPos(p => ({ ...p, y: p.y - step }));
                        e.preventDefault();
                        break;
                    case 'ArrowDown':
                        setPos(p => ({ ...p, y: p.y + step }));
                        e.preventDefault();
                        break;
                    case 'ArrowLeft':
                        setPos(p => ({ ...p, x: p.x - step }));
                        e.preventDefault();
                        break;
                    case 'ArrowRight':
                        setPos(p => ({ ...p, x: p.x + step }));
                        e.preventDefault();
                        break;
                    default:
                        break;
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    // We repeat the pattern block to fill the background
    // Increased count to ensure coverage on large screens
    const blocks = [...Array(40)];

    return (
        <>
            <div className="bauhaus-pattern-wrapper" style={{ transform: `translate(${pos.x}px, ${pos.y}px)` }}>
                {blocks.map((_, index) => (
                    <div key={index} className="pattern-container">
                        <div className="tile bg-mid">
                            <div className="shape-leaf bg-tan"></div>
                        </div>
                        <div className="tile bg-tan">
                            <div className="shape-house color-dark"></div>
                        </div>
                        <div className="tile bg-mid">
                            <div className="shape-leaf bg-dark rotate-90"></div>
                        </div>
                        <div className="tile bg-dark">
                            <div className="shape-arcs color-tan"></div>
                        </div>

                        <div className="tile bg-mid">
                            <div className="shape-leaf bg-white rotate-270"></div>
                        </div>
                        <div className="tile bg-tan">
                            <div className="shape-circle color-dark"></div>
                        </div>
                        <div className="tile bg-dark">
                            <div className="shape-leaf bg-tan rotate-180"></div>
                        </div>
                        <div className="tile bg-white">
                            <div className="shape-house color-mid"></div>
                        </div>

                        <div className="tile bg-dark">
                            <div className="shape-sparkle-bg">
                                <div className="shape-sparkle-inner"></div>
                            </div>
                        </div>
                        <div className="tile bg-tan">
                            <div className="shape-leaf bg-mid rotate-90"></div>
                        </div>
                        <div className="tile bg-mid">
                            <div className="shape-arcs color-white" style={{ top: 0, right: 0, bottom: 'auto', left: 'auto', transform: 'translate(50%, -50%)' }}></div>
                        </div>
                        <div className="tile bg-tan">
                            <div className="shape-leaf bg-dark"></div>
                        </div>
                    </div>
                ))}
            </div>
            <div style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                background: 'rgba(0,0,0,0.6)',
                color: 'rgba(255,255,255,0.8)',
                padding: '6px 10px',
                borderRadius: '4px',
                fontSize: '11px',
                fontFamily: 'monospace',
                zIndex: 10,
                pointerEvents: 'none',
                border: '1px solid rgba(255,255,255,0.2)'
            }}>
              
            </div>
        </>
    );
};

export default BauhausPattern;
